// Stock changes (Inventory page + the AI's adjust_stock card): the reasons, the one message for a change below 0, the card's
// lines table. The database says the same (sql/quick-wins.sql: hc_stock_change(), inventory_stock_history, the trigger that
// refuses negative stock). Plain JS, no imports - the server and the tests use it too.

export const STOCK_REASONS = [['used', 'Used'], ['received', 'Received'], ['guest_consumption', 'Guest consumption'], ['damaged', 'Damaged'], ['count_correction', 'Count correction']]
// apa_purchase: written only by the APA (sql/feat-10b.sql apa_stock) - shown in the history, never a reason to pick
export const STOCK_REASON_LABEL = { ...Object.fromEntries(STOCK_REASONS), apa_purchase: 'APA purchase', other: 'Other (no reason given)' }
export const STOCK_REASON_KEYS = STOCK_REASONS.map(r => r[0])

// the same words as the database message (hc_stock_change / hc_stock_not_negative)
export const negativeStockMessage = (name, before, after) => 'Stock cannot go below 0: ' + (name || 'this item') + ' has ' + fmtQty(before) + ', the change would make it ' + fmtQty(after) + '.'
export const fmtQty = v => { const n = Number(v); return Number.isFinite(n) ? String(Math.round(n * 1000) / 1000) : '0' }

// a reason in the user's words -> one of the keys (null when it does not say): "we used", "delivered", "guests drank", "broken", "after a count"
export function reasonFromText(text, change) {
  const t = String(text || '').toLowerCase()
  if (/guest|charter guests?|owner'?s party/.test(t)) return 'guest_consumption'
  if (/damag|broke|broken|leak|spoil|expired|faulty|smash|crack/.test(t)) return 'damaged'
  if (/count|stock ?take|inventory check|correct/.test(t)) return 'count_correction'
  if (/receiv|deliver|arriv|restock|bought|purchas|came in|\bgot\b/.test(t)) return 'received'
  if (/\bused?\b|consum|fitted|replaced|took|taken|install/.test(t)) return 'used'
  if (change != null && Number(change) > 0) return 'received'
  if (change != null && Number(change) < 0) return 'used'
  return null
}

// the card / confirmation table: every line, never cut. items: [{ name, uid, location, before, after }]
export const STOCK_TABLE_COLUMNS = ['Item', 'Place', 'Before', 'After', 'Change']
export function stockTable(items) {
  return {
    columns: STOCK_TABLE_COLUMNS,
    rows: (items || []).map(i => {
      const d = (Number(i.after) || 0) - (Number(i.before) || 0)
      return [i.name + (i.uid ? ' (' + i.uid + ')' : ''), i.location || '–', fmtQty(i.before), fmtQty(i.after), (d > 0 ? '+' : '') + fmtQty(d)]
    }),
  }
}
